"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ERROR_UNEXPECTED = exports.ERROR_UNAUTHENTICATED = exports.ERROR_PERMISSION_DENIED = exports.ERROR_NOT_FOUND = exports.ERROR_NETWORK_CONNECTIVITY = void 0;
var ERROR_NETWORK_CONNECTIVITY = 'ERROR_NETWORK_CONNECTIVITY';
exports.ERROR_NETWORK_CONNECTIVITY = ERROR_NETWORK_CONNECTIVITY;
var ERROR_NOT_FOUND = 'ERROR_NOT_FOUND';
exports.ERROR_NOT_FOUND = ERROR_NOT_FOUND;
var ERROR_PERMISSION_DENIED = 'ERROR_PERMISSION_DENIED';
exports.ERROR_PERMISSION_DENIED = ERROR_PERMISSION_DENIED;
var ERROR_UNAUTHENTICATED = 'ERROR_UNAUTHENTICATED';
exports.ERROR_UNAUTHENTICATED = ERROR_UNAUTHENTICATED;
var ERROR_UNEXPECTED = 'ERROR_UNEXPECTED';
exports.ERROR_UNEXPECTED = ERROR_UNEXPECTED;
var _default = {
  ERROR_NETWORK_CONNECTIVITY: ERROR_NETWORK_CONNECTIVITY,
  ERROR_NOT_FOUND: ERROR_NOT_FOUND,
  ERROR_PERMISSION_DENIED: ERROR_PERMISSION_DENIED,
  ERROR_UNAUTHENTICATED: ERROR_UNAUTHENTICATED,
  ERROR_UNEXPECTED: ERROR_UNEXPECTED
};
exports.default = _default;